import { useEffect } from 'react';

const useDocTitle = (title) => {
    useEffect(() => {
        if (title) {
            document.title = `${title} - X-Bass`;
        } else {
            document.title = 'X-Bass | The Perfect Audio Store';
        }
    }, [title]);

    return null;
};

export default useDocTitle;
